import {AfterContentInit, Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[appAutofocus]'
})
export class AutofocusDirective implements AfterContentInit {

  constructor(private host: ElementRef) {}

  ngAfterContentInit() {
    this.host.nativeElement.focus();
  }

  focus() {
    if(this.host) {
      this.host.nativeElement.focus();
    }
  }
}
